export type EventHandler = (value?: any) => void;

export const subscribe = (event: string, handler: EventHandler) => {
	const handleEvent = (e: Event) => {
		handler('detail' in e ? e.detail : undefined);
	};

	window.addEventListener(event, handleEvent);

	return () => window.removeEventListener(event, handleEvent);
};

export const emit = (event: string, value?: unknown) => {
	window.dispatchEvent(new CustomEvent(event, { detail: value }));
};
